import { ChatStateWithOptionalId } from '../hooks/useChats/reducer/chatListReducer.types';
import {
  AddVideoCallInActiveChatPayload,
  ChatActions,
  OpenRoomsOfGroupPayload,
  RemoveChatFromMinimizedPayload,
  UpdateSelectedChatPayload,
} from './chatReducer.types';

export const updateSelectedChat = (payload?: UpdateSelectedChatPayload): ChatActions => ({
  type: 'UPDATE_SELECTED_CHAT',
  payload,
});

export const openChatCreation = (): ChatActions => ({
  type: 'OPEN_CHAT_CREATION',
});

export const openGroupChatCreation = (): ChatActions => ({
  type: 'OPEN_GROUP_CHAT_CREATION',
});

export const openPrivateChat = (chat: ChatStateWithOptionalId): ChatActions => ({
  type: 'OPEN_PRIVATE_CHAT',
  payload: { chat },
});

export const resetState = (): ChatActions => ({
  type: 'RESET_STATE',
});

export const errorConnectionToWs = (): ChatActions => ({
  type: 'ERROR_CONNECTING_TO_WS',
});

export const openRoomsOfGroup = (payload: OpenRoomsOfGroupPayload): ChatActions => ({
  type: 'OPEN_ROOMS_OF_GROUP',
  payload,
});

export const openGroupedRooms = (): ChatActions => ({
  type: 'OPEN_GROUPED_ROOMS',
});

export const closeActiveChat = (): ChatActions => ({
  type: 'CLOSE_ACTIVE_CHAT',
});

export const minimizeActiveChat = (): ChatActions => ({
  type: 'MINIMIZE_ACTIVE_CHAT',
});

export const removeChatFromMinimized = (payload: RemoveChatFromMinimizedPayload): ChatActions => ({
  type: 'REMOVE_CHAT_FROM_MINIMIZED',
  payload,
});

export const addVideoCallInActiveChat = (
  payload: AddVideoCallInActiveChatPayload,
): ChatActions => ({
  type: 'ADD_VIDEO_CALL_IN_ACTIVE_CHAT',
  payload,
});

export const deleteVideoCall = (): ChatActions => ({
  type: 'DELETE_VIDEO_CALL',
});
